import React, { useState } from "react";
import { Link } from "react-router-dom";
import './Navbar.css'

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="navbar">
      <div className="navbar-container">
        <div className="navbar-top">
          <div className="logo">
            <img src="/logo.jpg" alt="" />
            <a href="/" className="logoName">
            Sangam Resort & Banquet
            </a>
          </div>
          
       
          <button 
            className="hamburger"
            onClick={toggleMenu}
            aria-label="Toggle navigation menu"
          >
            <span className={`bar ${isOpen ? 'active' : ''}`}></span>
            <span className={`bar ${isOpen ? 'active' : ''}`}></span>
            <span className={`bar ${isOpen ? 'active' : ''}`}></span>
          </button>
        </div>


        <nav className={`nav-links ${isOpen ? "open" : ""}`}>
          <Link to='/' className="link">Home</Link>
            <Link to='/about' className="link">About Us</Link>

           <Link to='/events' className="link" >Events</Link>
           <Link to='/contact' className="link">Contact Us</Link>
              <Link to='/gallery' className="link">Gallery</Link>
        </nav>

        {/* Call Button */}
        <div className="call-button">
          <a href="tel:+918340539463">📞 +91 8340539463</a>
        </div>
      </div>

     
    </header>
  );
};

export default Navbar;